import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4" }
const _hoisted_2 = { class: "text-right col-span-full" }
const _hoisted_3 = { class: "flex flex-col mt-4 overflow-hidden" }
const _hoisted_4 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_5 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_6 = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_7 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 年月 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 報酬額/税額 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 販売数量 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 販売回数 ")
  ])
], -1)
const _hoisted_9 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_10 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "px-6 py-4 text-sm text-right text-gray-500 whitespace-nowrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "px-6 py-4 text-sm text-right text-gray-500 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-4 text-sm text-right text-gray-500 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-color-3 hover:bg-color-3 focus:outline-none focus:ring-3 focus:ring-offset-3 focus:ring-color-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadCsv && _ctx.downloadCsv(...args)))
        }, " 振込CSVダウンロード ")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affeliates, (affeliate) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: affeliate.id
                  }, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(affeliate.target_name), 1),
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatYmd(affeliate.ymd, "MM月DD日")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createTextVNode(" ¥" + _toDisplayString(affeliate.price) + " ", 1),
                      _hoisted_13,
                      _createTextVNode("¥" + _toDisplayString(affeliate.tax), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(affeliate.quantity), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(affeliate.count), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}